import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import CreateFamilyTree from './components/CreateFamilyTree';
import RegisterMember from './components/RegisterMember';
import FamilyTreeDisplay from './components/FamilyTreeDisplay';
import AuthGate from './AuthGate';
import Dashboard from './components/Dashboard';
import Header from './components/Header';
import Footer from './components/Footer';
import Profile from './components/Profile';
import FamilyHome from './components/FamilyHome';
import EventCalendar from './components/EventCalendar';
import BirthdayTracker from './components/BirthdayTracker';
import FamilyHub from './components/FamilyHub';
import FamilyMedia from './components/FamilyMedia';
import FamilyDirectory from './components/FamilyDirectory';
import Callback from './Callback';
import InfoPage from './components/InfoPage';
import ToastProvider from './components/ToastProvider';
import ProfileGate from './components/ProfileGate';

function AppRoutes() {
  return (
    <AuthGate>
    <Router>
          
      {/* Main Container */}
      <div className="bg-white rounded-b-3xl shadow-2xl overflow-hidden mx-auto">
      <Header/>
        <ToastProvider/>
        <Routes>
          
           <Route path="/" element={<ProfileGate><Dashboard /></ProfileGate>} />
          <Route path="/dashboard" element={<ProfileGate><Dashboard /></ProfileGate>} />
          {/* <Route path="/callback" element={<Callback />} /> */}
          <Route path="/register" element={<ProfileGate><RegisterMember /></ProfileGate>} />
          <Route path="/display" element={<ProfileGate><FamilyTreeDisplay /></ProfileGate>} />
          <Route path="/createFamilyTree" element={<ProfileGate><CreateFamilyTree /></ProfileGate>} />
          <Route path="/familyTree/:id" element={<ProfileGate><FamilyTreeDisplay /></ProfileGate>} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/familyHome/:id" element={<ProfileGate><FamilyHome /></ProfileGate>} />
           <Route path="/familyMedia/:id" element={<ProfileGate><FamilyMedia /></ProfileGate>} />
           <Route path="/familyDirectory/:id" element={<ProfileGate><FamilyDirectory /></ProfileGate>} />
          <Route path="/birthdayTracker/:id" element={<ProfileGate><BirthdayTracker /></ProfileGate>} />

           {/* JSON-based pages */}
   <Route path="/:page" element={<InfoPage />} /> 
        </Routes>
     
      <Footer/>
       </div>
    </Router>
    </AuthGate>
  );
}


export default AppRoutes;